import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImac: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"imac, computer"} maskId="square-filled-radius-0-stroke-1-IconImac"><path d="M2 3V13H22V3H2Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M2 18V14H22V18H15V22H9V18H2ZM10 18V21H14V18H10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconImac;
